import { useEffect } from "react";
import AnimatedBackground from "./components/AnimatedBackground";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SectionDivider from "./components/SectionDivider";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Projects from "./sections/Projects";
import Experience from "./sections/Experience";
import Achievements from "./sections/Achievements";
import Resume from "./sections/Resume";
import Contact from "./sections/Contact";
import { useCursor } from "./hooks/useCursor";

function CursorLayer() {
  const { dotRef, ringRef } = useCursor();
  return (
    <>
      <div ref={dotRef} className="cursor-dot" />
      <div ref={ringRef} className="cursor-ring" />
    </>
  );
}

export default function App() {
  // Re-register hover listeners after all sections mount
  useEffect(() => {
    const timer = setTimeout(() => {
      const dot = document.querySelector(".cursor-dot");
      const ring = document.querySelector(".cursor-ring");
      const onEnter = () => {
        dot?.classList.add("hovered");
        ring?.classList.add("hovered");
      };
      const onLeave = () => {
        dot?.classList.remove("hovered");
        ring?.classList.remove("hovered");
      };
      document.querySelectorAll("a, button, [data-hover]").forEach((el) => {
        el.removeEventListener("mouseenter", onEnter);
        el.removeEventListener("mouseleave", onLeave);
        el.addEventListener("mouseenter", onEnter);
        el.addEventListener("mouseleave", onLeave);
      });
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen" style={{ background: "#0a0a0f" }}>
      {/* Canvas background */}
      <AnimatedBackground />

      {/* Cursor */}
      <CursorLayer />

      {/* Navigation */}
      <Navbar />

      {/* Main content */}
      <main>
        <Hero />
        <SectionDivider />
        <About />
        <SectionDivider />
        <Skills />
        <SectionDivider />
        <Projects />
        <SectionDivider />
        <Experience />
        <SectionDivider />
        <Achievements />
        <SectionDivider />
        <Resume />
        <SectionDivider />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
